import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  afterNextRender,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthService,
  SocialUser,
} from '@abacritt/angularx-social-login';
import { environment } from '../../../environments/environment';
import { TakerService } from '../shared/taker.service';
import { Taker } from 'src/app/pages/taker/taker-profile/taker.model';
import { ActivitiesService } from '../activities/activities.service';
import { isPlatformBrowser } from '@angular/common';

const FRONT_URL = environment.frontUrl;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [TranslateModule, FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  @Input() loginData: any;
  loginForm: UntypedFormGroup;
  alert = { message: null, type: null };
  constructor(
    private authService: AuthService,
    // private socialAuthService: SocialAuthService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private takerService: TakerService,
    private activityService: ActivitiesService,
    public translate: TranslateService,
    private elem: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.loginForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });

    afterNextRender(() => {
      this.initializeGoogleSignIn();
    });
  }

  ngOnInit() {
    if (this.loginData.email) {
      this.loginForm.controls['email'].setValue(this.loginData.email);
      this.loginForm.controls['password'].setValue(
        atob(this.loginData.password)
      );
    }
  }

  initializeGoogleSignIn() {
    // Aquí reemplaza 'TU_CLIENT_ID' con tu Client ID de Google
    google.accounts.id.initialize({
      client_id:
        '306399346139-snsajbsqgf2dc48eeptm1ir0v94k00hi.apps.googleusercontent.com',
      callback: this.handleCredentialResponse.bind(this),
    });

    // Renderiza el botón de Google Sign-In
    google.accounts.id.renderButton(
      this.elem.nativeElement.querySelector('#buttonDiv'),
      { theme: 'outline', size: 'large' } // puedes personalizar el botón aquí
    );
  }

  handleCredentialResponse(response: any) {
    // console.log("Token de ID de Google: ", response.credential);
    // Envía el token a tu backend o realiza la lógica de autenticación aquí

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.authService.loginByGoogle(response.credential, 'ROLE_MAKER').then(
      (response) => {
        // console.log('Respuesta después token: ' + response);
        // window.location.reload();

        // this.saveFavoriteExperiences();

        setTimeout(() => {
          this.alert = { message: null, type: null };
          if (this.authService.hasMakerRole()) {
            window.location.replace(
              FRONT_URL +
                this.translate.getDefaultLang() +
                '/maker/admin/perfil/'
            );
          } else if (this.authService.hasTakerRole()) {
            window.location.replace(
              FRONT_URL +
                this.translate.getDefaultLang() +
                '/taker/admin/perfil/'
            );
          } else if (this.authService.hasResellerRole()) {
            window.location.replace(
              FRONT_URL +
                this.translate.getDefaultLang() +
                '/reseller/admin/perfil/'
            );
          }
        }, 1000);
        // this.router.navigateByUrl(this.translate.getDefaultLang() + '/maker/admin/perfil/');
      },
      (error) => {
        this.alert.type = 2;
        this.alert.message =
          'Ocurrió un error al intentar hacer login con Google, por favor vuelve a intentarlo';
      }
    );
  }

  login() {
    const loginModel = this.loginForm.value;
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.authService
      .login(loginModel.email, loginModel.password)
      .then(() => {
        this.alert.type = 1;
        this.alert.message = 'Login correcto';

        this.saveFavoriteActivities();

        setTimeout(() => {
          this.alert = { message: null, type: null };
          if (this.authService.hasMakerRole()) {
            window.location.replace(
              FRONT_URL +
                this.translate.getDefaultLang() +
                '/maker/admin/perfil/'
            );
          } else if (this.authService.hasTakerRole()) {
            window.location.replace(
              FRONT_URL +
                this.translate.getDefaultLang() +
                '/taker/admin/perfil/'
            );
          } else if (this.authService.hasResellerRole()) {
            window.location.replace(
              FRONT_URL +
                this.translate.getDefaultLang() +
                '/reseller/admin/perfil/'
            );
          }
        }, 1000);
      })
      .catch((error) => {
        this.alert.message = error.error.code + '- ' + error.error.message;
        this.alert.type = 2;
        setTimeout(() => {
          this.alert = { message: null, type: null };
        }, 5000);
      });
  }

  saveFavoriteActivities() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const storedFavorites = JSON.parse(
      localStorage.getItem('favoriteActivities') || '[]'
    );

    console.log('localStorage favorites: ', storedFavorites);

    if (this.takerService.getId() && storedFavorites) {
      this.activityService
        .getActivitiesByTakerId(this.takerService.getId())
        .subscribe((activities) => {
          // var takerFavorites = experiences[ 'hydra:member' ];

          const takerFavorites = activities['hydra:member'].map(
            (exp) => exp['@id']
          );

          // Mezclar y eliminar duplicados
          const combinedFavorites = [
            ...new Set([...storedFavorites, ...takerFavorites]),
          ];

          localStorage.setItem(
            'favoriteActivities',
            JSON.stringify(combinedFavorites)
          );

          const taker = {
            favoriteActivities: combinedFavorites,
          };

          // Enviar los cambios al backend
          const editedTaker = new Taker(taker);
          this.takerService
            .putTaker(this.takerService.getId(), editedTaker)
            .subscribe();
        });
    }
  }

  /*   loginWithFB() {
      this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID).then((user: SocialUser) => {
        this.authService.loginByFacebook(user, 'ROLE_MAKER')
          .then(
            (response) => {
              setTimeout(() => {
                this.alert = {message: null, type: null};
                if (this.authService.hasMakerRole()) {
                  window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/maker/admin/perfil/');
                } else if (this.authService.hasTakerRole()) {
                  window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/taker/admin/perfil/');
                } else if (this.authService.hasResellerRole()) {
                  window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/reseller/admin/perfil/');
                }
                // window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/maker/admin/perfil/');
                // this.router.navigateByUrl(this.translate.getDefaultLang() + '/maker/admin/perfil/');
              }, 1000);
            },
            (error) => {
              this.alert.type = 2;
              this.alert.message = 'Ocurrió un error al intentar hacer login con Facebook, por favor vuelve a intentarlo';
            });
      });
    }
  
    loginWithGoogle() {
      this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID, { uxMode: 'redirect' }).then((user: SocialUser) => {
        console.log('usuario: ' + user);
        this.authService.loginByGoogle(user.idToken, 'ROLE_MAKER')
          .then(
            (response) => {
              // window.location.reload();
              setTimeout(() => {
                this.alert = {message: null, type: null};
                if (this.authService.hasMakerRole()) {
                  window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/maker/admin/perfil/');
                } else if (this.authService.hasTakerRole()) {
                  window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/taker/admin/perfil/');
                } else if (this.authService.hasResellerRole()) {
                  window.location.replace(FRONT_URL + this.translate.getDefaultLang() + '/reseller/admin/perfil/');
                }
              }, 1000);
              // this.router.navigateByUrl(this.translate.getDefaultLang() + '/maker/admin/perfil/');
            },
            (error) => {
              this.alert.type = 2;
              this.alert.message = 'Ocurrió un error al intentar hacer login con Google, por favor vuelve a intentarlo';
            });
      });
    } */
}
